import { jsx as r } from "react/jsx-runtime";
import { Label as m } from "@radix-ui/react-label";
import { Text as s } from "../Text/Text.mjs";
import { cn as c } from "../../../utils/utils.mjs";
const b = ({ className: e, children: t, fontWeight: a, fontSize: l, fontFamily: o, ...i }) => /* @__PURE__ */ r(m, { asChild: !0, className: c("dark:text-neutral-dark-1000", e), ...i, children: /* @__PURE__ */ r(s, { asChild: !0, fontWeight: a, fontSize: l, fontFamily: o, children: /* @__PURE__ */ r("label", { children: t }) }) });
export {
  b as Label
};
